import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import { useAuth } from "../../contexts";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales/ETLCodes";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface ICopyButtonProps extends ICustomButtonProps {
  byPassRights?: boolean;
}

export const CopyButton: React.FunctionComponent<ICopyButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.NONE,
  byPassRights = false
}) => {
  const { t } = useTl();
  const { getCurrentPermission } = useAuth();
  const hasRights = React.useMemo(() => getCurrentPermission()?.permission?.includes("RW"), [getCurrentPermission]);

  return hasRights || byPassRights ? (
    <Button
      icon={IconNames.DUPLICATE}
      minimal={minimal}
      onClick={onClick}
      text={minimal ? null : t(ETLCodes.General_Copy)}
      intent={intent}
      loading={loading}
      disabled={disabled}
    />
  ) : (
    <></>
  );
};
